module.exports = __webpack_public_path__ + "components/resort-guide/item/static/icon-vertical-arrow--black-018d93ae4a7952dac0609b0811a9a0c8.svg";